module.exports = __webpack_public_path__ + "static/media/pink-s.5793a75e.svg";